import { InnerContentItem } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { useTranslation } from "react-i18next";

export function OneIdSummaryField({
  field,
}: {
  field: components["schemas"]["OneIDVerificationField"];
}) {
  const { t } = useTranslation();

  return (
    <>
      <InnerContentItem
        label={t("Country of issue")}
        testID="oneid-summary-country-of-issue"
      >
        {field.value?.issuing_country || "-"}
      </InnerContentItem>
      <InnerContentItem
        label={t("Document number")}
        testID="oneid-summary-document-number"
      >
        {field.value?.document_number || "-"}
      </InnerContentItem>
    </>
  );
}
